import { useMutation } from "@apollo/client";
import { UPDATE_SELLING_LIMITATIONS } from "../pharmacyTypeDefs";

export const useMutationUpdateSellingLimitations = (options?: any): any => (
  useMutation(UPDATE_SELLING_LIMITATIONS, options)
);
